import React, { useContext } from "react";
import { AppContext } from "../Index";
import FamilyGroup from "./FamilyGroup";

const FamilyGroupDetails = () => {
  const appStoreData = useContext(AppContext);
  const { filteredMenuData, setSearchText, searchText } = appStoreData;

  return (
    <div className="col-lg-6 right-cover">
      <div className="search-cover">
        <input
          type="text"
          className="w-100 pl-2 py-2 pr-6 mb-3 form-control search-field"
          placeholder="Search menu item"
          value={searchText}
          onChange={(ev) => setSearchText(ev.target.value)}
        />
      </div>
      <div className="item-list-cover scroll">
        <div className="accordion" id="accordionExample">
          {filteredMenuData.map((fg) => (
            <FamilyGroup familyGroup={fg} key={fg.itemCode} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default FamilyGroupDetails;
